import { render, staticRenderFns } from "./TagComponents.vue?vue&type=template&id=35f33060&"
import script from "./TagComponents.vue?vue&type=script&lang=js&"
export * from "./TagComponents.vue?vue&type=script&lang=js&"
import style0 from "./TagComponents.vue?vue&type=style&index=0&id=35f33060&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports